import { createStore } from 'vuex'

export default createStore({
  state: {
    userInfo: {
      address: '',
      balance: '0',
      chainId: 0,
      redPackContractAddr: ''
    }
  },
  mutations: {
    SET_USERINFO (state, pay) {
      state.userInfo = pay
    },
    CLEAR_USERINFO (state) {
      state.userInfo.address = ''
      state.userInfo.balance = '0'
      state.userInfo.chainId = 0
      state.userInfo.redPackContractAddr = ''
    }
  },
  actions: {
  },
  modules: {
  }
})
